import React, { useState } from "react";
import { setAdminPassword } from "../../api/api";
import { useLocation } from "react-router-dom";
import PasswordInput from "../../features/Shared/Utils/PasswordInput";
import styles from "./SetPassword.module.css";

const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const token = query.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage({ text: "Passwords do not match.", type: "error" });
      return;
    }
    try {
      const response = await setAdminPassword(token, password, confirmPassword);
      setMessage({ text: response.data.message, type: "success" });
    } catch (error) {
      setMessage({
        text: error.response ? error.response.data.error : error.message,
        type: "error",
      });
    }
  };

  return (
    <div className={styles.setPasswordContainer}>
      <form onSubmit={handleSubmit} className={styles.setPasswordForm}>
        {message.text && (
          <div className={`${styles.message} ${styles[message.type]}`}>
            {message.text}
          </div>
        )}
        <h2>Set Password</h2>
        <div className={styles.formGroup}>
          <label>Password:</label>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
        </div>
        <div className={styles.formGroup}>
          <label>Confirm Password:</label>
          <PasswordInput
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
          />
        </div>
        <button type="submit" className={styles.submitButton}>
          Set Password
        </button>
      </form>

      {message.type === "success" && (
        <div className={styles.successFooter}>
          <p className={styles.successMsg}>
            🎉 All set! You can now access your TennisShop Admin Dashboard:
          </p>
          <a
            href="https://admin-dashboard.tennisshopworld.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.loginButton}
          >
            Go to Dashboard
          </a>
        </div>
      )}
    </div>
  );
};

export default SetPassword;
